import {useSurvey} from "utils";
import {useTranslation} from "react-i18next";

export function Goals({className}) {
  const {t} = useTranslation('common', {keyPrefix: 'summarize.goals'})

  const {
    goal,
    surveyList,
    state: {resultList},
    getSurveyByIndex
  } = useSurvey()

  const
    goalTitle = goal?.short || goal?.title,

    s2 = surveyList.findIndex(({id}) => id === 'target2'),
    g2 = +resultList?.[s2]?.[0] || 0,
    survey2 = getSurveyByIndex(s2),
    goalTitle2 = survey2?.list?.[g2]?.short || survey2?.list?.[g2]?.title || goalTitle,

    goalHeader = t('list', {returnObjects: true})

  return (
    <div className={'row small-sm text-start' + (className ? ' ' + className : '')}>
      <div className={'surface row gap-3'}>
        <img width={24} height={24} alt={'Goal'} src={'/static/img/icon/goal.svg'}/>
        <div>
          <p className={'mb-01 notice-2'}>
            {goalHeader[0]}
          </p>
          {goalTitle}
        </div>
      </div>
      <div className={'surface row gap-3'}>
        <img width={24} height={24} alt={'Goal'} src={'/static/img/icon/amount.svg'}/>
        <div>
          <p className={'mb-01 notice-2'}>
            {goalHeader[1]}
          </p>
          {goalTitle2}
        </div>
      </div>
    </div>
  )
}